<div class="loading-dots"><span>.</span><span>.</span><span>.</span></div>